import { fetchWithAwsWaf } from 'lib/security/awsWaf';

import logProviderFactory from './logger/logProviderFactory';

export function ReadJSON<ResponseType>(
    file: string,
    onErr?: (error: any) => void,
    retry: number = 0,
): Promise<ResponseType> {
    const headers = file.includes('.gz') ? { 'Accept-Encoding': 'gzip' } : undefined;
    return fetchWithAwsWaf(file, { headers })
        .then((response) => {
            if (response.status !== 200) {
                return Promise.reject(response);
            }
            return response.json();
        })
        .catch((error) => {
            // Ignore 404 errors for optional series descriptions.
            if (error.status === 404 && error.url.includes('/product-info/series_descriptions/series_description_')) {
                return;
            }

            // Retry logic
            if (retry < 3) {
                return ReadJSON(file, onErr, retry + 1);
            }

            const message = `Failed to read JSON from ${file}: ${error}`;
            logProviderFactory.logError(message, error);
            if (onErr) {
                onErr(error);
            }
        });
}
